import React from "react";
import { Box, BoxProps } from '@mui/material';
import { type FC } from 'react';
import DOMPurify from 'dompurify';

interface IHtmlRenderer extends BoxProps {
  content: string;
  isMobile?: boolean;
  isServerRendering?: boolean;
  container?: any;
}

const HtmlRenderer: FC<IHtmlRenderer> = ({
  content,
  isMobile = false,
  isServerRendering,
  container,
  ...props
}: IHtmlRenderer): React.ReactElement => {
  const CustomContainer: any = container || Box;
  const sanitizeHtml = (html: string): string => {
    html = String(html);
    return html ? DOMPurify?.sanitize(html) : '';
  };
  return (
    <CustomContainer
      className={isMobile ? 'mobile-container' : null}
      dangerouslySetInnerHTML={{
        __html: isServerRendering ? content : sanitizeHtml(content),
      }}
      sx={{
        lineHeight: '1.5',
        '& > ol, & > ul': {
          padding: 0,
          margin: 0
        },
        '.first-level::marker, .first-level h5': {
          fontWeight: 700,
          fontSize: '16px',
          margin: 0,
        },
        '*': {
          marginBottom: '16px'
        },
        ...(isMobile && {
          '& > ol, & > ul': {
            padding: '16px',
            margin: 0
          },
          '.first-level ol, .first-level ul': {
            paddingLeft: '16px'
          },
        })
      }}
      {...props}
    />
  );
};

export default HtmlRenderer;
